import { memo, useState } from 'react'
import styled from 'styled-components'
const TagSwapper = styled.div`
  margin: 1rem 0;
  cursor: pointer;
  display: flex;
`
const Tag = styled.div`
  background:#f5f5f5;
  padding: 10px 30px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  border-radius: 6px;
  border: 1px solid #e6ebf5;
  font-size: 16px;
  font-weight: bold;
  margin-right: .8rem;
  display: flex;
  align-items:center;
`
interface PropsType {
  tags: string[];
  callBack: (tag: number) => void;
  currentIndex: number;
  bgColor?: string;
}

function App(props: PropsType) {
  const { tags, callBack, currentIndex, bgColor = '#1fc7d4' } = props
  const tagClick = (index: number) => {
    callBack(index)
  }

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modelKey, setModelKey] = useState('')
  const modelCallBack = () => {
    setIsModalOpen(false)
  }
  const helpClick = (key: string) => {
    setModelKey(key)
    setIsModalOpen(true)
  }

  return (
    <TagSwapper>
      {/* <Model callBack={modelCallBack} isModalOpen={isModalOpen} content={ModelContent[modelKey]} /> */}
      {
        tags.map((item, index) => (
          <Tag key={index} onClick={() => tagClick(index)}
            style={{ background: (index === currentIndex) ? `${bgColor}` : '' }}>
            {item}
            {/* <HelpIcon ml='8px' color='red' onClick={() => helpClick(item)} /> */}
          </Tag>
        ))
      }
    </TagSwapper>
  )
}

export default memo(App)